import ValueButton from 'components/ValueButton';
import useControllerOperatorLis from '../../Operator/OperatorList/_presenters/useControllerOperatorList/useControllerOperatorList';
import { Spinner } from 'reactstrap';
import { useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

type ValueListProps = {
  ddd: string;
};

const ValueList = ({ ddd }: ValueListProps) => {
  const { operadoras, isLoading } = useControllerOperatorLis({ ddd });
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const operadora = useMemo(() => {
    const operatorCode = searchParams.get('operator');
    return operadoras?.find((operator: any) => operator.code === operatorCode);
  }, [operadoras, searchParams]);

  const goToRechargeDetail = (value: number) => {
    navigate(`/recarga/details?${searchParams.toString()}&value=${value}`);
  };

  return (
    <div className="d-flex flex-column align-items-center mt-3">
      <p className="font-size-3 font-color fw-medium mb-5">
        Qual é o valor da recarga?
      </p>
      {isLoading && <Spinner />}
      {operadora?.products.map((value: any) => (
        <ValueButton
          key={value.id}
          value={value.value}
          onClick={() => {
            goToRechargeDetail(value.value);
          }}
        />
      ))}
    </div>
  );
};

export default ValueList;
